import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { delay, share } from 'rxjs/operators';
import { Objects } from '../../common/util/objects';

@Injectable()
export class LayoutService {
  
  constructor() {
    const useHeader = sessionStorage.getItem('u-h');
    this._useHeader = useHeader ? Objects.parseBoolean(useHeader) : true;
  }

  protected layoutSize$ = new Subject();

  private _useHeader: boolean = true;

  changeLayoutSize() {
    this.layoutSize$.next();
  }

  onChangeLayoutSize(): Observable<any> {
    return this.layoutSize$.pipe(share(), delay(1));
  }

  public set useHeader(value: boolean) {
    sessionStorage.setItem('u-h', String(value));
    this._useHeader = value;
  }

  public get useHeader(): boolean {
    return this._useHeader;
  }
}
